import React from 'react';
import { withRouter, Link, NavLink } from 'react-router-dom';

import { hasStoredToken, deleteToken, getPaymentTier, getOfferValidDate } from 'utils/authentication';
// import FullStory from 'react-fullstory';
import Announcement from 'component/content/announcement';


export function daysLeft(date) {

  if (date === null){
    return '';
  }

  var seconds = Math.floor((date - new Date()) / 1000);

  var interval = Math.floor(seconds / 31536000);

  // if (interval > 1) {
  //   return interval + " years";
  // }
  // interval = Math.floor(seconds / 2592000);
  // if (interval > 1) {
  //   return interval + " months";
  // }
  interval = Math.floor(seconds / 86400);
  // if (interval > 1) {
  return interval + " days";
  // }
  // interval = Math.floor(seconds / 3600);
  // if (interval > 1) {
  //   return interval + " hours";
  // }
  // interval = Math.floor(seconds / 60);
  // if (interval > 1) {
  //   return interval + " minutes";
  // }
  // return Math.floor(seconds) + " seconds";
}


class Nav extends React.Component {

  constructor (props) {
    super(props);
    this.logout = this.logout.bind(this);
  }

  logout () {
    deleteToken();
    this.props.history.push('/');
  }

  render () {

    let tier_name = null;
    let offer_valid_date = null;
    if (hasStoredToken()){
      tier_name = getPaymentTier();
      offer_valid_date = daysLeft(getOfferValidDate());
    }

    const ORG_ID = process.env.REACT_APP_FULLSTORY_ORG_ID; // 'Q77PR';

    return(
      <section className={ ((tier_name === null)? (' fixed-top'): (' ')) }>

      {((tier_name === null)? (<Announcement />): (' '))}

      <nav className={"navbar navbar-expand-lg p-0 bg-white box-shadow " }>

        {/* <FullStory org={ORG_ID} /> */}

        <div className="navbar-header">
          {(tier_name === null)? (
            <Link to="/" className="navbar-brand text-spacing-2 mr-2 text-size-1 family-title">
              <img style={{height: "40px"}} className="hero mx-3" src="/static/images/cursor.svg" alt="Divshow product cursor" />
              <span className="text-size-3" > <span className="text-dark">Div</span><span className="text-quaternary">Show</span> </span>
              
            </Link>
          ): (
            <div className="">
              <Link to="/sites" className="navbar-brand text-spacing-2 mr-2">
                <img style={{height: "20px"}} className="hero mx-3" src="/static/images/cursor.svg" alt="Divshow product cursor" />
                <span className="text-dark">Div</span><span className="text-quaternary">Show</span>
              </Link>
              <Link to="/billing" className=""><sup className="badge badge-quaternary uppercase">{tier_name + (offer_valid_date? " - " + offer_valid_date + ' left': '')}</sup></Link>
            </div>
          )}
        </div>

        <button className="navbar-toggler btn btn-quaternary text-white mr-2" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <i className="fas fa-bars"></i>
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav mr-auto">
            <li className="nav-item active">
            </li>
          </ul>

          { hasStoredToken() ? (
            <ul className="navbar-nav my-0 my-lg-0">
              <li className="nav-item">
                <NavLink activeClassName="highlight-quaternary-8" className="highlight-quaternary-1 btn btn-rounded mx-1 uppercase" to="/instructions"><span className="fa fa-eye mr-2"></span>Instructions</NavLink>
              </li>
              <li className="nav-item">
                <NavLink activeClassName="highlight-quaternary-8" className="highlight-quaternary-1 btn btn-rounded mx-1 uppercase" to="/sites"><span className="fa fa-list mr-2"></span>Sites</NavLink>
              </li>
              <li className="nav-item">
                <NavLink activeClassName="highlight-quaternary-8" className="highlight-quaternary-1 btn btn-rounded mx-1 uppercase" to="/analytics">
                  <span className="fa fa-chart-bar mr-2"></span>Analytics<sup className="ml-2 badge badge-dark uppercase">{"beta"}</sup>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink activeClassName="highlight-quaternary-8" className="highlight-quaternary-1 btn btn-rounded mx-1 uppercase" to="/billing"><span className="fa fa-coins mr-2"></span>Billing</NavLink>
              </li>

              <li className="nav-item dropdown">
                <Link className=" btn mx-1 uppercase dropdown-toggle" to="/" id="navbarDropdown1" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <span className="fa fa-cog mr-2"></span>Settings&nbsp;
                </Link>
                <div className="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown1">
                  {/* <Link className="dropdown-item" to="/sites">Home</Link> */}
                  <Link className="dropdown-item" to="/instructions">Instructions</Link>
                  <Link className="dropdown-item" to="/analytics">Analytics</Link>
                  <Link className="dropdown-item" to="/account">Account</Link>
                  <Link className="dropdown-item" to="/billing">Billing</Link>
                  <hr className="my-2"/>
                  <a className="dropdown-item" href="https://blog.bytebeacon.com">Blog</a>
                  <Link className="dropdown-item" to="/faq">FAQ</Link>
                  <Link className="dropdown-item" to="/legal/tos">Terms</Link>
                  <Link className="dropdown-item" to="/legal/privacy">Privacy</Link>
                  <hr className="my-2"/>
                  <button className="dropdown-item" onClick={this.logout}>
                    <span className="fa fa-power-off mr-2"></span>Logout
                  </button>
                </div>
              </li>

            </ul>
          ): (
            <ul className="navbar-nav my-0 my-lg-0">
              {/* <li className="nav-item">
                <NavLink activeClassName="highlight-quaternary-8" className="highlight-quaternary-1 btn btn-rounded m-2 text-spacing-2 uppercase" to="/">Home</NavLink>
              </li> */}
              <li className="nav-item">
                <NavLink activeClassName="highlight-quaternary-8" className="highlight-quaternary-1 btn btn-rounded m-2 text-spacing-2 uppercase" to="/pricing">Pricing</NavLink>
              </li>
              <li className="nav-item">
                <NavLink activeClassName="highlight-quaternary-8" className="highlight-quaternary-1 btn btn-rounded m-2 text-spacing-2 uppercase" to="/faq">FAQ</NavLink>
              </li>
              <li className="nav-item">
                <a className="highlight-primary-1 btn btn-rounded m-2 text-spacing-2 uppercase" href="https://blog.bytebeacon.com">Blog</a>
              </li>
              <li className="nav-item black-bl-1-1">
              </li>
              <li className="nav-item">
                <NavLink to="/login" className="btn btn-quaternary btn-rounded text-white text-spacing-2 m-2 uppercase"><i className="fa fa-paper-plane mr-2"></i>Start free</NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/login" className="btn btn-outline-quaternary btn-rounded text-spacing-2 m-2 uppercase"><i className="fa fa-sign-in-alt mr-2"></i>Login</NavLink>
              </li>
              
            </ul>
          )}

        </div>

      </nav>
      </section>
    )
  }
}


export default withRouter(Nav);
